import React, { useRef } from 'react';
import { Trash2, Upload } from 'lucide-react';

export function SiteImageAssetSlot({
    label,
    hint,
    value,
    busy,
    onUpload,
    onRemove,
    testId,
    previewHeight = 56,
    wide = false,
}) {
    const inputRef = useRef(null);

    return (
        <div className="panel admin-panel" style={{ marginBottom: '1rem' }} data-testid={testId}>
            <h3 className="headline admin-panel__title">{label}</h3>
            {hint && (
                <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', margin: '0 0 0.85rem', lineHeight: 1.5 }}>
                    {hint}
                </p>
            )}
            {value ? (
                <div style={{ marginBottom: '0.75rem' }}>
                    <img
                        src={value}
                        alt=""
                        style={{
                            maxHeight: previewHeight,
                            maxWidth: wide ? '100%' : 220,
                            width: wide ? '100%' : 'auto',
                            objectFit: 'contain',
                            borderRadius: 10,
                            border: '1px solid var(--border)',
                            background: '#fff',
                            padding: '0.35rem',
                            display: 'block',
                        }}
                    />
                </div>
            ) : (
                <div style={{
                    minHeight: previewHeight,
                    maxWidth: wide ? '100%' : 220,
                    borderRadius: 10,
                    marginBottom: '0.75rem',
                    border: '1px dashed var(--border-strong)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'var(--text-faint)',
                    fontSize: '0.85rem',
                    padding: '0.75rem',
                    textAlign: 'center',
                }}>
                    Nicio imagine încă
                </div>
            )}
            <input
                ref={inputRef}
                type="file"
                accept="image/*"
                style={{ display: 'none' }}
                onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (file) onUpload(file);
                    e.target.value = '';
                }}
            />
            <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
                <button type="button" className="btn btn-secondary btn-sm" disabled={busy} onClick={() => inputRef.current?.click()}>
                    {busy ? <span className="spinner" /> : <Upload size={13} />} {value ? ' Înlocuiește' : ' Încarcă'}
                </button>
                {value && (
                    <button type="button" className="btn btn-danger btn-sm" disabled={busy} onClick={onRemove}>
                        <Trash2 size={13} /> Șterge
                    </button>
                )}
            </div>
        </div>
    );
}
